/*eslint-disable*/
import React from "react"
import Question from "./Question"
import { questions } from "../../pages/faq/data";

const Faq = () => {
  return (
    <section className='mx-auto max-w-7xl py-8 md:pb-16'>
      <div className='w-full flex items-start flex-wrap md:pb-16 md:pt-10 px-4 sm:px-6 lg:px-8'>
        <div className='w-full md:w-1/2 pb-8 sm:pb-12 lg:pl-10'>
          <h1 className='text-3xl md:text-5xl font-bold leading-relaxed'>
            Frequently Asked Questions
          </h1>
        </div>

        <div className='w-full md:w-1/2'>
          {questions?.slice(0, 4)?.map((question, index) => (
            <div
              key={index}
              data-aos='zoom-in-up'
              data-aos-duration='1000'
              data-aos-delaydata-aos-delay={`${index > 0 ? 200 * index : 0}`}
            >
              <Question
                title={question.title}
                answer={question.answer}
                key={question.id}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Faq
